"use client";

import { createContext, useContext } from "react";

/** Apps with a central settings screen hide the inline preference controls. */
export const ExternalLearningSettingsContext = createContext(false);
export const useExternalLearningSettings = () =>
  useContext(ExternalLearningSettingsContext);
